var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistrautoRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8581 22.7434H39.6934V29.6839H77.8581V22.7434Z",
    fill: "#18315A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.935 15.4858H78.124V20.8762H118.935V15.4858Z",
    fill: "#18315A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.608 32.4497H78.124V37.84H131.608V32.4497Z",
    fill: "#18315A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147 49.4133H78.124V54.8037H147V49.4133Z",
    fill: "#18315A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.608 66.377H78.124V71.7673H131.608V66.377Z",
    fill: "#18315A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.685 83.3408H78.124V88.7312H105.685V83.3408Z",
    fill: "#18315A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.935 100.304H78.124V105.695H118.935V100.304Z",
    fill: "#18315A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.608 117.277H78.124V122.667H131.608V117.277Z",
    fill: "#18315A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147 134.241H78.124V139.631H147V134.241Z",
    fill: "#18315A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0329 40.1565H39.8682V47.097H78.0329V40.1565Z",
    fill: "#18315A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0329 108.02H39.8682V114.961H78.0329V108.02Z",
    fill: "#18315A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0329 90.6072H39.8682V97.5477H78.0329V90.6072Z",
    fill: "#18315A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8581 6H39.6934V12.9405H77.8581V6Z",
    fill: "#18315A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0329 73.8638H39.8682V80.8043H78.0329V73.8638Z",
    fill: "#18315A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8972 21.9773H39.7763V13.9358H0V22.4177H38.8972V21.9773Z",
    fill: "#18315A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8975 22.4177H39.2912V22.356H39.7765V21.9685H38.8975V22.4177Z",
    fill: "#18315A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7672 22.356H39.291V22.4176H39.7672V22.356Z",
    fill: "#18315A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7671 30.8994H0V39.3813H39.7671V30.8994Z",
    fill: "#18315A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.8633V56.3539H39.7671V47.8633H39.0621H0Z",
    fill: "#18315A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0621 73.0885H39.7671V64.8357H0V73.3176H39.0621V73.0885Z",
    fill: "#18315A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7666 73.0886H39.0615V73.3088H39.7666V73.0886Z",
    fill: "#18315A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0621 89.832H39.7671V81.7993H0V90.2812H39.0621V89.832Z",
    fill: "#18315A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0615 90.2812H39.4644V90.2196H39.7666V89.832H39.0615V90.2812Z",
    fill: "#18315A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7762 90.2197H39.4648V90.2814H39.7762V90.2197Z",
    fill: "#18315A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7671 98.7632H0V107.245H39.7671V98.7632Z",
    fill: "#18315A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 115.727V124.209H39.7671V115.727H39.0621H0Z",
    fill: "#18315A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7671 132.69H0V141.172H39.7671V132.69Z",
    fill: "#18315A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrautoRDefault);
export default __webpack_public_path__ + "static/media/registrauto-r-default.055d18de72526d1f18735073c451cf2f.svg";
export { ForwardRef as ReactComponent };